import { IconButton, Paper, Stack } from '@mui/material'
import { DataGrid } from '@mui/x-data-grid'
import { useTranslation } from 'react-i18next'
import Header from 'components/Header'
import IconProvider from 'components/IconProvider'
import NoRecords from 'components/NoRecords'
import { EditIcon } from 'components/Icons'
import { hasFullPermission } from 'store'

export default function AttendanceSettingsList({ rows, incidentItems, setSelected }) {
  const { t } = useTranslation()

  const canEdit = hasFullPermission('attendance.settings')

  const renderYesNo = value => (value ? t('Yes') : t('No'))

  const renderIncident = incidents => {
    const incidentItemId = incidents?.[0]?.incidentItemId
    if (!incidentItemId) return '-'

    const incidentItem = incidentItems?.find(item => Number(item.id) === Number(incidentItemId))
    if (!incidentItem) return '-'

    return `${incidentItem.name} (${incidentItem.point})`
  }

  const columns = [
    {
      field: 'name',
      headerName: t('Type'),
      flex: 1.5,
      minWidth: 200,
      renderCell: ({ row }) => (
        <Stack direction="row" spacing={1} alignItems="center">
          <IconProvider icon={row.ui?.icon} color={row.ui?.color} />
          <span>{row.name}</span>
        </Stack>
      ),
    },
    {
      field: 'absent',
      headerName: t('Absent'),
      width: 110,
      valueGetter: renderYesNo,
    },
    {
      field: 'excused',
      headerName: t('Excused'),
      width: 110,
      valueGetter: renderYesNo,
    },
    {
      field: 'stateExcused',
      headerName: t('State Excused'),
      width: 140,
      valueGetter: renderYesNo,
    },
    {
      field: 'dailyIncident',
      headerName: t('Demerit Point (Daily)'),
      flex: 1,
      minWidth: 180,
      valueGetter: renderIncident,
    },
    {
      field: 'periodIncident',
      headerName: t('Demerit Point (Period)'),
      flex: 1,
      minWidth: 185,
      valueGetter: renderIncident,
    },
    ...(canEdit
      ? [
          {
            field: 'actions',
            headerName: t('Actions'),
            width: 90,
            sortable: false,
            renderCell: ({ row }) => (
              <IconButton size="small" onClick={() => setSelected(row)}>
                <EditIcon fontSize="small" />
              </IconButton>
            ),
          },
        ]
      : []),
  ]

  return (
    <Paper sx={{ width: '100%', p: 2, mb: 2 }}>
      <div style={{ marginLeft: -10 }}>
        <Header title={t('Attendance Settings')} small />
      </div>

      <DataGrid
        rows={rows ?? []}
        columns={columns}
        getRowId={row => row.id}
        autoHeight
        hideFooter
        disableColumnMenu
        rowHeight={56}
        loading={!rows}
        slots={{ noRowsOverlay: NoRecords }}
        slotProps={{ loadingOverlay: { variant: 'circular-progress', noRowsVariant: 'circular-progress' } }}
        sx={{
          '--DataGrid-overlayHeight': '200px',
          '& .MuiDataGrid-cell': { display: 'flex', alignItems: 'center' },
        }}
      />
    </Paper>
  )
}
